import { useMatches } from '@tanstack/react-router';
import type { ShellRouteData } from '../router.js';

/** Manifest data of the deepest matched module route (`undefined` on `/` and 404). */
export function useActiveRoute(): ShellRouteData | undefined {
  const matches = useMatches();
  for (let i = matches.length - 1; i >= 0; i--) {
    const data = matches[i]?.staticData?.shell;
    if (data) return data;
  }
  return undefined;
}
